<template>
  <div class="app-router">
    <h2 class="font-weight-bold text-capitalize">Halo, {{ userData.user_name }}!</h2>
    <div class="text-subtitle-2 pb-5">Berikut ini adalah ringkasan informasi yang terjadi di tokomu</div>
    <div
      class="d-block red--text text-subtitle-2 pb-5"
      v-if="detailStore.store_is_active=='inactive'"
    >Saat ini toko kamu sedang tidak aktif sehingga tidak bisa menerima transaksi. Silakan kontak Admin untuk mengaktifkan kembali.</div>
    <div class="d-block subtitle-1 red--text mt-4 text-right" v-if="userData">
      <span style="margin-right:10px;" @click="copyme" class="cursor-pointer">
        <span class="pl-1">Bagikan Tautan Toko</span>
        <input type="hidden" :value="getUrlReferal()" id="inputCopy" />
      </span>
    </div>
    <!-- {{userData}} -->
    <!-- {{detailStore}} -->
    <template v-if="!loading">
      <v-card
        id="panel-reminder"
        elevation="1"
        outlined
        class="mt-5"
        v-if="(!detailStore.store_latitude || !detailStore.store_longitude) || !hasProduct || !hasUpdateCourier || !hasUpdateBankAccount"
      >
        <v-card-subtitle>
          <h4 class="pb-3 black--text">Yuk Lengkapi Data Tokomu</h4>
          <hr />
        </v-card-subtitle>
        <v-card-text>
          <div class="reminder-list">
            <carousel
              :loop="false"
              :responsive="{
                0: { items: 1 },
                600: { items: 2 },
                1000: { items: 2 }
              }"
              :nav="false"
              :dots="false"
              :margin="5"
            >
              <div
                class="pa-1"
                v-if="(!detailStore.store_latitude || !detailStore.store_longitude)"
              >
                <router-link :to="'/seller'" class="text-deco">
                  <v-card elevation="1" outlined class="reminder-item">
                    <v-card-text>
                      <div class="reminder-content">
                        <div class="reminder-text">
                          <h4>Atur Titik Pengiriman!</h4>
                          <div class="text-caption">Agar kamu bisa menggunakan layanan Instant.</div>
                          <router-link :to="'/seller/profile-toko-v3'" class="Reminder-action mt-2">
                            Lengkapi Alamat Toko
                            <v-icon
                              :left="true"
                              class="d-inline primary--text"
                              dense
                            >mdi-chevron-right</v-icon>
                          </router-link>
                        </div>
                        <v-img width="50" src="/assets/seller/atur-pengiriman-barang.svg"></v-img>
                      </div>
                    </v-card-text>
                  </v-card>
                </router-link>
              </div>
              <div class="pa-1" v-if="!hasProduct">
                <router-link :to="'/seller'" class="text-deco">
                  <v-card elevation="1" outlined class="reminder-item">
                    <v-card-text>
                      <div class="reminder-content">
                        <div class="reminder-text">
                          <h4>Upload Barang Pertamamu!</h4>
                          <div
                            class="text-caption"
                          >Makin cepat jualan, makin cepat untungnya. Yuk upload barangmu segera.</div>
                          <router-link :to="'/seller/tambah-produk'" class="Reminder-action mt-2">
                            Upload Barang
                            <v-icon
                              :left="true"
                              class="d-inline primary--text"
                              dense
                            >mdi-chevron-right</v-icon>
                          </router-link>
                        </div>
                        <v-img width="20" src="/assets/seller/upload-barang-pertama.svg"></v-img>
                      </div>
                    </v-card-text>
                  </v-card>
                </router-link>
              </div>

              <div class="pa-1" v-if="!hasUpdateCourier">
                <router-link :to="'/seller'" class="text-deco">
                  <v-card elevation="1" outlined class="reminder-item">
                    <v-card-text>
                      <div class="reminder-content">
                        <div class="reminder-text">
                          <h4>Atur Pengiriman Barang!</h4>
                          <div class="text-caption">
                            Agar kamu bisa kirim pesanan dengan cepat dan mudah, atur jasa
                            pengiriman sekarang.
                          </div>
                          <router-link
                            :to="'/seller/pengaturan-pengiriman'"
                            class="Reminder-action mt-2"
                          >
                            Lengkapi Data ini
                            <v-icon
                              :left="true"
                              class="d-inline primary--text"
                              dense
                            >mdi-chevron-right</v-icon>
                          </router-link>
                        </div>
                        <v-img width="20" src="/assets/seller/atur-pengiriman-barang.svg"></v-img>
                      </div>
                    </v-card-text>
                  </v-card>
                </router-link>
              </div>

              <div class="pa-1" v-if="!hasUpdateBankAccount">
                <router-link :to="'/seller'" class="text-deco">
                  <v-card elevation="1" outlined class="reminder-item">
                    <v-card-text>
                      <div class="reminder-content">
                        <div class="reminder-text">
                          <h4>Atur Rekening Bank!</h4>
                          <div
                            class="text-caption"
                          >Agar kamu mudah cairkan hasil penjualan, atur rekeningmu sekarang.</div>
                          <router-link :to="'/seller/rekening-bank'" class="Reminder-action mt-2">
                            Lengkapi Data ini
                            <v-icon
                              :left="true"
                              class="d-inline primary--text"
                              dense
                            >mdi-chevron-right</v-icon>
                          </router-link>
                        </div>
                        <v-img width="50" src="/assets/seller/atur-rekening-bank.svg"></v-img>
                      </div>
                    </v-card-text>
                  </v-card>
                </router-link>
              </div>

              <template slot="prev">
                <v-card elevation="0" class="col-12 pa-0" v-if="showReminder > 2">
                  <v-btn x-small color="white" elevation="3" fab class="prev prev-other-reminder">
                    <v-icon color="grey darken-1">mdi-chevron-left</v-icon>
                  </v-btn>
                </v-card>
              </template>
              <template slot="next">
                <v-card elevation="0" class="col-12 pa-0" v-if="showReminder > 2">
                  <v-btn x-small color="white" elevation="3" fab class="next next-other-reminder">
                    <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
                  </v-btn>
                </v-card>
              </template>
            </carousel>
          </div>
        </v-card-text>
      </v-card>
    </template>
    <v-row v-show="false">
      <v-col class="col-md-4 col-12">
        <v-card-text>
          <div class="stats-content">
            <div class="stats-text">
              <router-link :to="'/history-coin-gen'">
                <div
                  class="d-block text-h4 font-weight-bold text-center black--text"
                >{{ saldoCoinGen |toRupiah }}</div>
              </router-link>
              <div class="d-block text-center text-caption">Saldo Coin Gen</div>
            </div>
          </div>
        </v-card-text>
      </v-col>
      <v-col class="col-md-4 col-12">
        <!-- {{ saldo }} -->
        <v-card-text>
          <div class="stats-content">
            <div class="stats-text">
              <router-link :to="'/seller/penghasilan-saya'">
                <div
                  class="d-block text-h4 font-weight-bold text-center black--text"
                >{{ saldo.total_balance || 0 |toRupiah }}</div>
              </router-link>
              <div class="d-block text-center text-caption">Saldo Toko</div>
            </div>
          </div>
        </v-card-text>
      </v-col>
      <v-col class="col-md-4 col-12" v-if="showStockiestMenu">
        <v-card-text>
          <div class="stats-content">
            <div class="stats-text">
              <router-link :to="'/seller/deposit-reseller'">
                <div
                  class="d-block text-h4 font-weight-bold text-center black--text"
                >{{ saldoDepositReseller |toRupiah }}</div>
              </router-link>
              <div class="d-block text-center text-caption">Saldo Reseller</div>
            </div>
          </div>
        </v-card-text>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-md-6 col-12">
        <v-card id="panel-stats2" elevation="1" outlined class="mt-5">
          <v-card-subtitle>
            <h4 class="pb-3 black--text d-flex flex-row align-center">
              <v-img width="42" max-width="42" src="/assets/seller/produk.svg"></v-img>
              <span>Status Produk di Tokomu</span>
            </h4>
            <hr />
          </v-card-subtitle>
          <v-card-text>
            <v-tabs>
              <v-tab class="text-caption font-weight-bold">Produk Saya</v-tab>
              <v-tab
                class="text-caption font-weight-bold"
                v-if="userData.user_type === 'stockist'"
              >Produk Eksklusif</v-tab>

              <v-tab-item class="pt-4 pb-0">
                <div class="stats-list">
                  <v-card elevation="1" to="/seller/produk-saya" outlined class="stats-item">
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text">
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-if="!loading"
                          >{{ statsProdukEx.allProduct | toNumber }}</div>
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-else
                          >0</div>
                          <div class="d-block text-center text-caption">Jumlah Produk Saya Saat ini</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card
                    elevation="1"
                    to="/seller/produk-saya?type=live"
                    outlined
                    class="stats-item"
                  >
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text">
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-if="!loading"
                          >{{ statsProdukEx.activeProduct | toNumber }}</div>
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-else
                          >0</div>
                          <div class="d-block text-center text-caption">Produk Live</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card elevation="1" outlined class="stats-item">
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text">
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-if="!loading"
                          >{{ statsProdukEx.inactiveProduct | toNumber }}</div>
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-else
                          >0</div>
                          <div class="d-block text-center text-caption">Produk Tidak Aktif</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card
                    elevation="1"
                    to="/seller/produk-saya?type=habis"
                    outlined
                    class="stats-item"
                  >
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text">
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-if="!loading"
                          >{{ statsProdukEx.soldoutProduct | toNumber }}</div>
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-else
                          >0</div>
                          <div class="d-block text-center text-caption">Stok Habis</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-tab-item>

              <v-tab-item class="pt-4 pb-0">
                <div class="stats-list">
                  <v-card elevation="1" outlined class="stats-item">
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text">
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-if="!loading"
                          >{{ statsProdukIn.allProduct | toNumber }}</div>
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-else
                          >0</div>
                          <div
                            class="d-block text-center text-caption"
                          >Jumlah Produk Eksklusif Saat ini</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card elevation="1" outlined class="stats-item">
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text">
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-if="!loading"
                          >{{ statsProdukIn.activeProduct | toNumber }}</div>
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-else
                          >0</div>
                          <div class="d-block text-center text-caption">Produk Live</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card elevation="1" outlined class="stats-item">
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text">
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-if="!loading"
                          >{{ statsProdukIn.inactiveProduct | toNumber }}</div>
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-else
                          >0</div>
                          <div class="d-block text-center text-caption">Produk Tidak Aktif</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card elevation="1" outlined class="stats-item">
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text">
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-if="!loading"
                          >{{ statsProdukIn.soldoutProduct | toNumber }}</div>
                          <div
                            class="d-block text-h4 font-weight-bold text-center black--text"
                            v-else
                          >0</div>
                          <div class="d-block text-center text-caption">Stok Habis</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="col-md-6 col-12">
        <v-card id="panel-stats" elevation="1" outlined class="mt-5">
          <v-card-subtitle>
            <h4 class="pb-3 black--text d-flex flex-row align-center">
              <v-img width="42" max-width="42" src="/assets/seller/pesanan.svg"></v-img>
              <span>Status Transaksi Tokomu</span>
            </h4>
            <hr />
          </v-card-subtitle>
          <v-card-text>
            <v-tabs>
              <v-tab class="text-caption font-weight-bold">Pesanan Saya</v-tab>
              <v-tab
                class="text-caption font-weight-bold"
                v-if="userData.user_type === 'stockist'"
              >Pembelian Produk</v-tab>

              <v-tab-item class="pt-4 pb-0">
                <v-row class="row">
                  <div class="col-md-6 col-lg-6 col-xl-4 col-6">
                    <v-card to="/seller/pesanan-saya" elevation="1" outlined class="mx-1 my-1">
                      <v-card-text>
                        <div class="stats-content">
                          <div class="stats-text justify-space-between">
                            <div
                              class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                              v-if="!loading"
                            >{{ statsPesanan.allOrder | toNumber }}</div>
                            <div
                              class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                              v-else
                            >0</div>
                            <div
                              class="d-flex text-caption mx-auto text-center"
                            >Semua Pesanan Toko Saya saat ini</div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>

                  <div class="col-md-6 col-lg-6 col-xl-4 col-6">
                    <v-card
                      elevation="1"
                      to="/seller/pesanan-saya?type=waiting"
                      outlined
                      class="mx-1 my-1"
                    >
                      <v-card-text>
                        <div class="stats-content">
                          <div class="stats-text justify-space-between">
                            <div
                              class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                              v-if="!loading"
                            >{{ statsPesanan.created | toNumber }}</div>
                            <div
                              class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                              v-else
                            >0</div>
                            <div
                              class="d-flex text-caption mx-auto text-center"
                            >Pesanan Menunggu Pembayaran</div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>

                  <div class="col-md-6 col-lg-6 col-xl-4 col-6">
                    <v-card
                      elevation="1"
                      to="/seller/pesanan-saya?type=new"
                      outlined
                      class="mx-1 my-1"
                    >
                      <v-card-text>
                        <div class="stats-content">
                          <div class="stats-text justify-space-between">
                            <div
                              class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                              v-if="!loading"
                            >{{ statsPesanan.paid | toNumber }}</div>
                            <div
                              class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                              v-else
                            >0</div>
                            <div
                              class="d-flex text-caption mx-auto text-center"
                            >Pesanan Menunggu Diproses (Dibayar)</div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>

                  <div class="col-md-6 col-lg-6 col-xl-4 col-6">
                    <v-card
                      elevation="1"
                      to="/seller/pesanan-saya?type=ready"
                      outlined
                      class="mx-1 my-1"
                    >
                      <v-card-text>
                        <div class="stats-content">
                          <div class="stats-text justify-space-between">
                            <div
                              class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                              v-if="!loading"
                            >{{ statsPesanan.processed | toNumber }}</div>
                            <div
                              class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                              v-else
                            >0</div>
                            <div
                              class="d-flex text-caption mx-auto text-center"
                            >Pesanan Menunggu Dikirim</div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>

                  <div class="col-md-6 col-lg-6 col-xl-4 col-6">
                    <v-card
                      elevation="1"
                      to="/seller/pesanan-saya?type=pengiriman"
                      outlined
                      class="mx-1 my-1"
                    >
                      <v-card-text>
                        <div class="stats-content">
                          <div class="stats-text justify-space-between">
                            <div
                              class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                              v-if="!loading"
                            >{{ statsPesanan.delivered | toNumber }}</div>
                            <div
                              class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                              v-else
                            >0</div>
                            <div
                              class="d-flex text-caption mx-auto text-center"
                            >Pesanan Dalam Pengiriman</div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>

                  <div class="col-md-6 col-lg-6 col-xl-4 col-6">
                    <v-card
                      elevation="1"
                      to="/seller/pesanan-saya?type=selesai"
                      outlined
                      class="mx-1 my-1"
                    >
                      <v-card-text>
                        <div class="stats-content">
                          <div class="stats-text justify-space-between">
                            <div
                              class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                              v-if="!loading"
                            >{{ statsPesanan.completed | toNumber }}</div>
                            <div
                              class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                              v-else
                            >0</div>
                            <div
                              class="d-flex text-caption mx-auto text-center"
                            >Transaksi Pesanan Selesai</div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-row>
              </v-tab-item>

              <v-tab-item class="pt-4 pb-0">
                <div class="stats-list-lg">
                  <v-card elevation="1" outlined class="stats-item">
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text justify-space-between">
                          <div
                            class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                            v-if="!loading"
                          >{{ statsPembelian.allOrder | toNumber }}</div>
                          <div
                            class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                            v-else
                          >0</div>
                          <div
                            class="d-flex text-caption mx-auto text-center"
                          >Semua Pembelian Toko Saya saat ini</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card elevation="1" outlined class="stats-item">
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text justify-space-between">
                          <div
                            class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                            v-if="!loading"
                          >{{ statsPembelian.created | toNumber }}</div>
                          <div
                            class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                            v-else
                          >0</div>
                          <div
                            class="d-flex text-caption mx-auto text-center"
                          >Pembelian Produk Terbaru</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card elevation="1" outlined class="stats-item">
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text justify-space-between">
                          <div
                            class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                            v-if="!loading"
                          >{{ statsPembelian.pending | toNumber }}</div>
                          <div
                            class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                            v-else
                          >0</div>
                          <div
                            class="d-flex text-caption mx-auto text-center"
                          >Menunggu Verifikasi Pembayaran</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card elevation="1" outlined class="stats-item">
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text justify-space-between">
                          <div
                            class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                            v-if="!loading"
                          >{{ statsPembelian.paid | toNumber }}</div>
                          <div
                            class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                            v-else
                          >0</div>
                          <div
                            class="d-flex text-caption mx-auto text-center"
                          >Pembayaran sudah Diverifikasi</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card elevation="1" outlined class="stats-item">
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text justify-space-between">
                          <div
                            class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                            v-if="!loading"
                          >{{ statsPembelian.processed | toNumber }}</div>
                          <div
                            class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                            v-else
                          >0</div>
                          <div
                            class="d-flex text-caption mx-auto text-center"
                          >Pembelian sedang Diproses</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card elevation="1" outlined class="stats-item">
                    <v-card-text>
                      <div class="stats-content">
                        <div class="stats-text justify-space-between">
                          <div
                            class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                            v-if="!loading"
                          >{{ statsPembelian.completed | toNumber }}</div>
                          <div
                            class="d-flex text-h4 font-weight-bold text-center black--text justify-center"
                            v-else
                          >0</div>
                          <div
                            class="d-flex text-caption mx-auto text-center"
                          >Transaksi Pembelian Selesai</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card id="panel-resumestore" elevation="1" outlined class="mt-5 d-none">
      <v-card-subtitle>
        <h4 class="pb-3 black--text">Ringkasan Tokomu</h4>
        <hr />
      </v-card-subtitle>
      <v-card-text>
        <div class="resume-list">
          <v-row class="align-center">
            <v-col cols="3" class="py-0">
              <div class="resume-order">
                <div class="graph-order"></div>
                <div class="text-caption text-center">Belum pernah menerima pesanan</div>
              </div>
            </v-col>

            <v-col cols="5" class="py-0">
              <div class="resume-stats">
                <v-card elevation="0" outlined class="stats-item">
                  <v-card-text>
                    <div class="stats-content">
                      <div class="stats-text">
                        <v-img width="30" position="center left" src="/assets/seller/pelanggan.svg"></v-img>
                        <div class="d-block text-left font-weight-bold text-caption">Pelanggan</div>
                        <div class="d-block text-h5 font-weight-bold text-left black--text mt-1">0</div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <v-card elevation="0" outlined class="stats-item">
                  <v-card-text>
                    <div class="stats-content">
                      <div class="stats-text">
                        <v-img
                          width="40"
                          position="center left"
                          src="/assets/seller/waktu-kirim.svg"
                        ></v-img>
                        <div class="d-block text-left font-weight-bold text-caption">Waktu Kirim</div>
                        <div class="d-block text-h5 font-weight-bold text-left black--text mt-1">0</div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <v-card elevation="0" outlined class="stats-item">
                  <v-card-text>
                    <div class="stats-content">
                      <div class="stats-text">
                        <v-img
                          width="30"
                          position="center left"
                          src="/assets/seller/feedback-positif.svg"
                        ></v-img>
                        <div
                          class="d-block text-left font-weight-bold text-caption"
                        >Feedback Positif</div>
                        <div class="d-block text-h5 font-weight-bold text-left black--text mt-1">0</div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <v-card elevation="0" outlined class="stats-item">
                  <v-card-text>
                    <div class="stats-content">
                      <div class="stats-text">
                        <v-img
                          width="30"
                          position="center left"
                          src="/assets/seller/feedback-negatif.svg"
                        ></v-img>
                        <div
                          class="d-block text-left font-weight-bold text-caption"
                        >Feedback Negatif</div>
                        <div class="d-block text-h5 font-weight-bold text-left black--text mt-1">0</div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>

            <v-col cols="4" class="py-0">
              <div class="resume-rate">
                <div class="text-caption">Tingkat Reputasi</div>
                <div
                  class="d-block text-h6 font-weight-bold text-left black--text mb-2"
                >Belum ada reputasi</div>
                <div>
                  <!--<v-icon
                    small
                    color="yellow darken-1"
                    v-for="i in fullRating(5)"
                    :key="'full' + i"
                    >mdi-star</v-icon
                  >
                  <v-icon
                    small
                    color="yellow darken-1"
                    v-if="halfRating(2, 4)"
                    >mdi-star-half-full</v-icon
                  >-->
                  <v-icon
                    large
                    color="grey darken-1 text-h6"
                    v-for="i in nullRating(0)"
                    :key="'half' + i"
                  >mdi-star-outline</v-icon>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>

    <v-card id="panel-performstats" elevation="1" outlined class="mt-5 d-none">
      <v-card-subtitle>
        <h4 class="pb-3 black--text">Performa Tokomu</h4>
        <hr />
      </v-card-subtitle>
      <v-card-text>
        <v-tabs vertical>
          <v-tab class="panel-tab">Pesanan Terselesaikan</v-tab>
          <v-tab class="panel-tab">Pelayanan Pembeli</v-tab>
          <v-tab class="panel-tab">Kepuasan Pembeli</v-tab>

          <v-tab-item>
            <v-card flat>
              <v-card-text class="pl-5 pr-0 py-0">
                <v-simple-table class="custom-tables">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left" width="50%">Aspek</th>
                        <th class="text-right" width="25%">Toko Saya</th>
                        <th class="text-right">Target</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-left">Tingkat Pesanan Tidak Terselesaikan</td>
                        <td class="text-right">-</td>
                        <td class="text-right">&lt; 10%</td>
                      </tr>
                      <tr>
                        <td class="text-left">Tingkat Pembatalan</td>
                        <td class="text-right">-</td>
                        <td class="text-right">&lt; 5%</td>
                      </tr>
                      <tr>
                        <td class="text-left">Tingkat Pengembalian</td>
                        <td class="text-right">-</td>
                        <td class="text-right">&lt; 5%</td>
                      </tr>
                      <tr>
                        <td class="text-left">Tingkat Keterlambatan Pengiriman Pesanan</td>
                        <td class="text-right">-</td>
                        <td class="text-right">&lt; 10%</td>
                      </tr>
                      <tr>
                        <td class="text-left">Masa Pengemasan</td>
                        <td class="text-right">-</td>
                        <td class="text-right">&lt; 2%</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card flat>
              <v-card-text class="pl-5 pr-0 py-0">
                <v-simple-table class="custom-tables">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left" width="50%">Aspek</th>
                        <th class="text-right" width="25%">Toko Saya</th>
                        <th class="text-right">Target</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-left">Persentase Chat Dibalas</td>
                        <td class="text-right">57.00%</td>
                        <td class="text-right">&gt; 70%</td>
                      </tr>
                      <tr>
                        <td class="text-left">Waktu Chat Dibalas</td>
                        <td class="text-right">-</td>
                        <td class="text-right">&lt; 1%</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card flat>
              <v-card-text class="pl-5 pr-0 py-0">
                <v-simple-table class="custom-tables">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left" width="50%">Aspek</th>
                        <th class="text-right" width="25%">Toko Saya</th>
                        <th class="text-right">Target</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-left">Keseluruhan Penilaian</td>
                        <td class="text-right">-</td>
                        <td class="text-right">&gt; 4.5%</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import carousel from "vue-owl-carousel";
import auth from "@/helpers/auth";

export default {
  components: {
    carousel
  },
  data() {
    return {
      loading: false,
      loadingStats: false,
      hasProduct: false,
      hasUpdateBankAccount: false,
      hasUpdateCourier: false,
      showReminder: 0,
      params: [],
      statsProdukEx: {
        allProduct: 0,
        activeProduct: 0,
        inactiveProduct: 0,
        soldoutProduct: 0
      },
      statsProdukIn: {
        allProduct: 0,
        activeProduct: 0,
        inactiveProduct: 0,
        soldoutProduct: 0
      },
      statsPesanan: {
        allOrder: 0,
        created: 0,
        paid: 0,
        processed: 0,
        delivered: 0,
        completed: 0
      },
      statsPembelian: {
        allOrder: 0,
        created: 0,
        pending: 0,
        paid: 0,
        processed: 0,
        completed: 0
      }
    };
  },
  computed: {
    showStockiestMenu() {
      let user = auth.getUserData();
      if (user.user_is_stockist.toLowerCase() === "true") {
        return true;
      } else {
        return false;
      }
    },
    ...mapState("cart", ["saldoCoinGen", "saldoDepositReseller"]),
    ...mapState("auth", ["isAuth", "userData"]),
    ...mapState("storeSeller", ["detailStore"]),
    ...mapState("productSeller", ["productData", "productInternalData"]),
    ...mapState("transaksiSeller", ["statusPesanan"]),
    ...mapState("pembelianSeller", ["statusPembelian"]),
    ...mapState("saldoSeller", ["saldo"]),
  },
  methods: {
    ...mapActions("cart", ["getSaldoCoinGen", "getSaldoDepositReseller"]),
    ...mapActions("saldoSeller", ["getSaldoSummary"]),
    ...mapActions("storeSeller", ["getStoreDetail"]),
    ...mapActions("productSeller", ["getProductStat", "getProductInternalStats"]),
    ...mapActions("transaksiSeller", ["getStatusPesanan"]),
    ...mapActions("pembelianSeller", ["getStatusPembelian"]),

    async getStatsProdukEx(type) {
      switch (type) {
        case "all":
          this.params = [];
          break;

        case "live":
          this.params = [];
          this.params.push({
            value: "active",
            comparison: "=",
            type: "string",
            field: "product_is_active"
          });
          break;

        case "inactive":
          this.params = [];
          this.params.push({
            value: "inactive",
            comparison: "=",
            type: "string",
            field: "product_is_active"
          });
          break;

        case "sold-out":
          this.params = [];
          this.params.push({
            value: "0",
            comparison: "=",
            type: "numeric",
            field: "store_stock_quantity"
          });
          break;
      }
      await this.getProductStat(
        this.queryString({
          params: this.params
        })
      );

      return this.productData ? this.productData.length : 0;
    },

    async getStatsProdukIn(type) {
      switch (type) {
        case "all":
          this.params = [];
          break;

        case "live":
          this.params = [];
          this.params.push({
            value: "active",
            comparison: "=",
            type: "string",
            field: "product_is_active"
          });
          break;

        case "inactive":
          this.params = [];
          this.params.push({
            value: "inactive",
            comparison: "=",
            type: "string",
            field: "product_is_active"
          });
          break;

        case "sold-out":
          this.params = [];
          this.params.push({
            value: "0",
            comparison: "=",
            type: "numeric",
            field: "store_stock_quantity"
          });
          break;
      }
      await this.getProductInternalStats(
        this.queryString({
          params: this.params
        })
      );

      return this.productInternalData ? this.productInternalData.length : 0;
    },

    getStatsPesanan(status) {
      const allowedStatus =
        status === "all"
          ? ["created", "paid", "processed", "on_delivery", "completed"]
          : status;
      return this.filterAllowedStatus(this.statusPesanan, allowedStatus, "trx");
    },
    getStatsPembelian(status) {
      const allowedStatus =
        status === "all"
          ? ["created", "pending", "paid", "processed", "completed"]
          : status;
      return this.filterAllowedStatus(
        this.statusPembelian,
        allowedStatus,
        "po"
      );
    },

    filterAllowedStatus(data, allowedStatus, type) {
      let showList =
        type === "trx"
          ? data.filter(d => allowedStatus.includes(d.trx_status))
          : data.filter(d => allowedStatus.includes(d.po_status));
      const counter = showList.reduce(
        (accumulator, current) =>
          parseInt(accumulator) + parseInt(current.count_status),
        0
      );
      return counter;
    },

    async getSummaries() {
      this.loadingStats = await true;
      await this.getStatusPesanan();
      await this.getStatusPembelian();
      this.statsProdukEx.allProduct = await this.getStatsProdukEx("all");
      this.statsProdukEx.activeProduct = await this.getStatsProdukEx("live");
      this.statsProdukEx.inactiveProduct = await this.getStatsProdukEx(
        "inactive"
      );
      this.statsProdukEx.soldoutProduct = await this.getStatsProdukEx(
        "sold-out"
      );

      this.statsProdukIn.allProduct = await this.getStatsProdukIn("all");
      this.statsProdukIn.activeProduct = await this.getStatsProdukIn("live");
      this.statsProdukIn.inactiveProduct = await this.getStatsProdukIn(
        "inactive"
      );
      this.statsProdukIn.soldoutProduct = await this.getStatsProdukIn(
        "sold-out"
      );

      this.statsPesanan = await {
        allOrder: this.getStatsPesanan("all"),
        created: this.getStatsPesanan(["created"]),
        paid: this.getStatsPesanan(["paid"]),
        processed: this.getStatsPesanan(["processed"]),
        delivered: this.getStatsPesanan(["on_delivery"]),
        completed: this.getStatsPesanan(["completed"])
      };
      this.statsPembelian = await {
        allOrder: this.getStatsPembelian("all"),
        created: this.getStatsPembelian(["created"]),
        pending: this.getStatsPembelian(["pending"]),
        paid: this.getStatsPembelian(["paid"]),
        processed: this.getStatsPembelian(["processed"]),
        completed: this.getStatsPembelian(["completed"])
      };
    },
    getUrlReferal() {
      let link = `${process.env.VUE_APP_DOMAIN}/store/${this.detailStore.store_slug}`;
      if (this.userData.user_network_id > 0) {
        link += `/${this.userData.user_mobilephone}`;
      }
      return link;
    },
    copyme() {
      var copyText = document.getElementById("inputCopy");
      copyText.setAttribute("type", "text");
      copyText.select();
      try {
        document.execCommand("copy");
        setTimeout(() => {
          this.$store.commit("makeAlert", {
            code: "success",
            type: "success",
            message: "Tautan berhasil disalin",
            show: true
          });
        }, 300);
      } catch (err) {
        alert("Oops, tidak dapat menyalin");
      }
      copyText.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    }
  },

  async mounted() {

  },

  async created() {
    this.getSaldoCoinGen();
    this.getSaldoDepositReseller();
    this.getSaldoSummary();
    this.loading = await true;
    await this.getStoreDetail();
    if (this.detailStore.store_stock.length > 0) this.hasProduct = await true;
    if (
      this.detailStore.store_bank_account_number &&
      this.detailStore.store_bank_name
    )
      this.hasUpdateBankAccount = await true;
    if (this.detailStore.store_courier) this.hasUpdateCourier = await true;

    if (this.hasProduct) await this.showReminder++;
    if (this.hasUpdateBankAccount) await this.showReminder++;
    if (this.hasUpdateCourier) this.showReminder = await this.showReminder++;

    this.getSummaries();

    this.loading = false;
    this.$store.dispatch("setPageTitle", `Dashboard Seller`);
  }
};
</script>

<style lang="scss" scoped>
#panel-reminder {
  // overflow: hidden;
  .reminder-list {
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
    .reminder-item {
      // display: inline-flex;
      // flex: 1 0 48%;
      // margin: 1% 1%;
      // flex-grow: 0;
      .reminder-content {
        display: flex;
        flex-direction: row;
        .reminder-text {
          display: inline-flex;
          flex-direction: column;
          width: 70%;
          padding-right: 5%;
        }
      }
    }
  }

  .prev-other-reminder {
    top: 60px;
    left: -34px;
  }
  .next-other-reminder {
    bottom: 70px;
    right: -34px;
  }
}

#panel-stats,
#panel-stats2 {
  .stats-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .stats-item {
      display: inline-flex;
      flex: 1 0 45%;
      margin: 2% 2%;
      flex-grow: 0;
      .stats-content {
        display: block;
        text-align: center;
        .text-caption {
          display: block;
          text-align: center;
          width: 90%;
          margin: 10px auto 0;
          line-height: 1.2;
          font-weight: bold;
        }
      }
    }
  }

  .stats-list-lg {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .stats-item {
      display: inline-flex;
      flex: 1 0 45%;
      margin: 1% 2%;
      flex-grow: 0;
      .stats-content {
        display: block;
        text-align: left;
        .text-caption {
          display: block;
          text-align: right;
          width: 75%;
          margin: 0;
          margin-left: 20px;
          line-height: 1.2;
          font-weight: bold;
          justify-content: flex-end;
        }
        .stats-text {
          display: inline-flex;
          flex-direction: row;
          justify-items: flex-start;
          align-items: center;
          width: 100%;
        }
      }
    }
  }
}

#panel-resumestore {
  .resume-list {
    display: flex;
    flex-direction: row;
    align-items: center;
    .resume-order {
      display: flex;
      flex-direction: column;
      .graph-order {
        display: block;
        width: 100%;
        height: 160px;
        border: 1px solid #ddd;
        margin: 0 auto 15px;
      }
    }
  }

  .resume-stats {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .stats-item {
      display: inline-flex;
      flex: 1 0 50%;
      margin: 0;
      flex-grow: 0;
      .stats-content {
        display: block;
        text-align: center;
        .text-caption {
          display: block;
          text-align: left;
          width: 100%;
          margin-top: 10px;
          line-height: 1.2;
        }
      }
    }
  }

  .resume-rate {
    display: flex;
    flex-direction: column;
  }
}

#panel-performstats {
  .panel-tab {
    font-size: 14px !important;
    text-transform: capitalize;
    text-align: left !important;
    letter-spacing: normal !important;
    justify-content: flex-start;
    margin-bottom: 5px;
    border-radius: 4px;
    font-weight: bold;
    &:hover,
    &:focus,
    &.v-tab--active {
      background: #00a651 !important;
      color: #fff !important;

      .v-tabs-slider {
        display: none !important;
      }
    }
  }

  .custom-tables {
    border: 1px solid #ddd;
    margin-bottom: 20px;
    thead {
      background: #ddd;
      th {
        color: #000;
        font-size: 14px;
        font-weight: bolder;
      }
    }
  }
}

@media (max-width: 599px) {
  #panel-stats,
  #panel-stats2 {
    margin-top: 0 !important;
    margin-bottom: 15px;
  }
  .stats-list {
    .stats-item {
      display: inline-flex;
      flex: 1 0 46% !important;
      margin: 2% 2%;
      flex-grow: 0;
    }
  }
  .stats-list-lg {
    .stats-item {
      display: inline-flex;
      flex: 1 0 100% !important;
      margin: 2% 0%;
      flex-grow: 0;
    }
  }
}
</style>
